module.exports = __webpack_public_path__ + "canny-asana-integration-c5b670a078f6f67d3e4ac5bd29766bd1.png";